/**
 * Borda ondulada entre seções. `color` = cor da seção que vem DEPOIS da onda
 * (ou antes, com `flip`). `animated` faz a onda balançar devagar, como água.
 */
export const Wave = ({ color, flip = false, animated = false, className = '' }) => (
  <div
    className={`w-full overflow-hidden leading-[0] pointer-events-none ${flip ? 'rotate-180' : ''} ${className}`}
    aria-hidden="true"
  >
    <svg
      viewBox="0 0 2880 120"
      preserveAspectRatio="none"
      className={`block h-[42px] md:h-[72px] ${animated ? 'w-[200%] animate-[waveslide_12s_linear_infinite]' : 'w-full'}`}
    >
      <path
        fill={color}
        d={
          animated
            ? 'M0 60 C 240 0, 480 0, 720 60 S 1200 120, 1440 60 S 1920 0, 2160 60 S 2640 120, 2880 60 L 2880 120 L 0 120 Z'
            : 'M0 70 C 320 10, 640 10, 960 60 S 1600 120, 1920 60 S 2560 0, 2880 50 L 2880 120 L 0 120 Z'
        }
      />
    </svg>
  </div>
);

export default Wave;
